import React from 'react'
import "react-datepicker/dist/react-datepicker.css";

function EditTitle({ TitleData, sendDataToParent }) {

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...TitleData,
      [name]: value
    });
  };
  

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">Title <span style={{ color: "red" }}>*</span></label>
          <input
            type="hidden"
            name="TitleId"
            value={TitleData.TitleId ?? ""}
          />
          <input
            type="text"
            className="form-control"
            name="Title"
            value={TitleData.Title ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea 
              className="form-control h-100" 
              rows="5" 
              name="Description"
              value={TitleData.Description ?? ""}
              onChange={handleChange}
            />
        </div>
      </div>
    </>
  )
}

export default EditTitle